import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const MessageTemplatesLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'MessageTemplates' */ './components/MessageTemplates'
		)
);

export default (store) => {
	return {
		path: 'message-templates',
		element: <AsyncLoading component={<MessageTemplatesLazy />} />,
	};
};
